// @generated by protobuf-ts 2.9.4 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "backend/v1/plan.proto" (package "backend.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { Struct } from "../../google/protobuf/struct";
import { Questionnaire } from "../../core/v1/questionnaire";
import { ShortfallFixes } from "../../core/v1/shortfall";
import { Date } from "../../core/v1/date";
import { Timestamp } from "../../google/protobuf/timestamp";
import { FinancialPlanData } from "../../core/v1/financial_plan";
/**
 * @generated from protobuf message backend.v1.FinancialPlanScenarios
 */
export interface FinancialPlanScenarios {
    /**
     * @generated from protobuf field: core.v1.FinancialPlanData abi_plan = 1;
     */
    abiPlan?: FinancialPlanData;
    /**
     * @generated from protobuf field: core.v1.FinancialPlanData naive_plan = 2;
     */
    naivePlan?: FinancialPlanData; // current trajectory; present only when requested
}
/**
 * An engine run, queued with pg-boss (architecture-redesign.md item E). Only its owner can read it.
 *
 * @generated from protobuf message backend.v1.PlanJob
 */
export interface PlanJob {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: backend.v1.PlanJob.Kind kind = 2;
     */
    kind: PlanJob_Kind;
    /**
     * @generated from protobuf field: backend.v1.PlanJob.State state = 3;
     */
    state: PlanJob_State;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp finished_at = 5;
     */
    finishedAt?: Timestamp;
    /**
     * @generated from protobuf field: string error_message = 6;
     */
    errorMessage: string; // user-safe summary when FAILED
    /**
     * @generated from protobuf field: int32 family_version = 7;
     */
    familyVersion: number;
    /**
     * @generated from protobuf field: string plan_uuid = 8;
     */
    planUuid: string; // KIND_PLAN and KIND_SHORTFALL_FIXES
    /**
     * @generated from protobuf field: string scenario_uuid = 9;
     */
    scenarioUuid: string; // KIND_SCENARIO
}
/**
 * @generated from protobuf enum backend.v1.PlanJob.Kind
 */
export enum PlanJob_Kind {
    /**
     * @generated from protobuf enum value: KIND_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * the household's plan (both runs)
     *
     * @generated from protobuf enum value: KIND_PLAN = 1;
     */
    PLAN = 1,
    /**
     * a Decisions what-if (Abi run only)
     *
     * @generated from protobuf enum value: KIND_SCENARIO = 2;
     */
    SCENARIO = 2,
    /**
     * fixes for a plan that runs short
     *
     * @generated from protobuf enum value: KIND_SHORTFALL_FIXES = 3;
     */
    SHORTFALL_FIXES = 3
}
/**
 * @generated from protobuf enum backend.v1.PlanJob.State
 */
export enum PlanJob_State {
    /**
     * @generated from protobuf enum value: STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: STATE_QUEUED = 1;
     */
    QUEUED = 1,
    /**
     * @generated from protobuf enum value: STATE_RUNNING = 2;
     */
    RUNNING = 2,
    /**
     * @generated from protobuf enum value: STATE_SUCCEEDED = 3;
     */
    SUCCEEDED = 3,
    /**
     * @generated from protobuf enum value: STATE_FAILED = 4;
     */
    FAILED = 4
}
/**
 * POST /api/plan-jobs: re-run the household's plan for the current family version (after a failed
 * job, or to move the start date to today). Saves queue their own job.
 *
 * @generated from protobuf message backend.v1.CreatePlanJobRequest
 */
export interface CreatePlanJobRequest {
    /**
     * @generated from protobuf field: core.v1.Date start_date = 1;
     */
    startDate?: Date; // optional; defaults to the user's current date
}
/**
 * GET /api/plan: the household's latest plan.
 *
 * @generated from protobuf message backend.v1.StoredPlan
 */
export interface StoredPlan {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: core.v1.Date start_date = 3;
     */
    startDate?: Date;
    /**
     * @generated from protobuf field: int32 family_version = 4;
     */
    familyVersion: number;
    /**
     * @generated from protobuf field: string engine_version = 5;
     */
    engineVersion: string;
    /**
     * @generated from protobuf field: backend.v1.FinancialPlanScenarios plans = 6;
     */
    plans?: FinancialPlanScenarios;
    /**
     * @generated from protobuf field: backend.v1.ShortfallFixesState shortfall_fixes_state = 7;
     */
    shortfallFixesState: ShortfallFixesState;
    /**
     * @generated from protobuf field: core.v1.ShortfallFixes shortfall_fixes = 8;
     */
    shortfallFixes?: ShortfallFixes;
    /**
     * The newest job since this plan, if it is queued or running ("updating your plan"). A failed one is `failed_job`.
     *
     * @generated from protobuf field: backend.v1.PlanJob pending_job = 9;
     */
    pendingJob?: PlanJob;
    /**
     * The household's latest plan job, when it failed after this plan was made: the plan shown is
     * older than the household's last change. Its error_message is user-safe. Cleared once a newer
     * plan succeeds. GET /api/plan's 404 (no plan) carries it as `failedJob` too.
     *
     * @generated from protobuf field: backend.v1.PlanJob failed_job = 10;
     */
    failedJob?: PlanJob;
}
/**
 * POST /api/scenarios: a Decisions what-if. The engine applies the changes to a copy of the stored
 * family; nothing is saved to the family. The result expires (Scenario.expires_at).
 *
 * @generated from protobuf message backend.v1.CreateScenarioRequest
 */
export interface CreateScenarioRequest {
    /**
     * @generated from protobuf field: backend.v1.DecisionTool tool = 1;
     */
    tool: DecisionTool;
    /**
     * @generated from protobuf field: core.v1.Questionnaire changes = 2;
     */
    changes?: Questionnaire;
    /**
     * @generated from protobuf field: google.protobuf.Struct inputs = 3;
     */
    inputs?: Struct; // the tool's form values, returned as-is for display
    /**
     * @generated from protobuf field: core.v1.Date start_date = 4;
     */
    startDate?: Date; // optional; defaults to the user's current date
    /**
     * The name shown in the saved list (the app's auto-title, e.g. "New job at $95,000"); trimmed, at
     * most 80 characters. Optional: without one the app titles the scenario from its inputs.
     *
     * @generated from protobuf field: string title = 5;
     */
    title: string;
    /**
     * Optional: a second set of changes, merged into its own copy of the stored family and run in the
     * same job as `changes` (both plans at once), for a what-if that compares two outcomes. The
     * insurance tool sends the event with the coverage held now here, and the event with the
     * coverage tested in `changes`. The job fails if either run fails.
     *
     * @generated from protobuf field: core.v1.Questionnaire comparison_changes = 6;
     */
    comparisonChanges?: Questionnaire;
}
/**
 * PATCH /api/scenarios/:id: rename a saved what-if (owner only). Trimmed, 1 to 80 characters.
 *
 * @generated from protobuf message backend.v1.RenameScenarioRequest
 */
export interface RenameScenarioRequest {
    /**
     * @generated from protobuf field: string title = 1;
     */
    title: string;
}
/**
 * @generated from protobuf message backend.v1.Scenario
 */
export interface Scenario {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: backend.v1.DecisionTool tool = 2;
     */
    tool: DecisionTool;
    /**
     * @generated from protobuf field: google.protobuf.Struct inputs = 3;
     */
    inputs?: Struct;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 5;
     */
    expiresAt?: Timestamp;
    /**
     * @generated from protobuf field: int32 family_version = 6;
     */
    familyVersion: number; // the family version the scenario was built on
    /**
     * @generated from protobuf field: core.v1.FinancialPlanData plan = 7;
     */
    plan?: FinancialPlanData; // set once the job has succeeded
    /**
     * @generated from protobuf field: backend.v1.PlanJob job = 8;
     */
    job?: PlanJob;
    /**
     * @generated from protobuf field: string title = 9;
     */
    title: string; // empty for scenarios saved before titles: the app titles them from `inputs`
    /**
     * The plan for CreateScenarioRequest.comparison_changes, set once the job has succeeded; unset when
     * the scenario was created without them (and for scenarios saved before they existed).
     *
     * @generated from protobuf field: core.v1.FinancialPlanData comparison_plan = 10;
     */
    comparisonPlan?: FinancialPlanData;
}
/**
 * @generated from protobuf message backend.v1.ListScenariosResponse
 */
export interface ListScenariosResponse {
    /**
     * @generated from protobuf field: repeated backend.v1.Scenario scenarios = 1;
     */
    scenarios: Scenario[]; // without plans
}
/**
 * @generated from protobuf enum backend.v1.ShortfallFixesState
 */
export enum ShortfallFixesState {
    /**
     * @generated from protobuf enum value: SHORTFALL_FIXES_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * the plan doesn't run short
     *
     * @generated from protobuf enum value: SHORTFALL_FIXES_STATE_NOT_NEEDED = 1;
     */
    NOT_NEEDED = 1,
    /**
     * @generated from protobuf enum value: SHORTFALL_FIXES_STATE_PENDING = 2;
     */
    PENDING = 2,
    /**
     * @generated from protobuf enum value: SHORTFALL_FIXES_STATE_READY = 3;
     */
    READY = 3,
    /**
     * @generated from protobuf enum value: SHORTFALL_FIXES_STATE_FAILED = 4;
     */
    FAILED = 4
}
/**
 * @generated from protobuf enum backend.v1.DecisionTool
 */
export enum DecisionTool {
    /**
     * @generated from protobuf enum value: DECISION_TOOL_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: DECISION_TOOL_EXPENSE = 1;
     */
    EXPENSE = 1,
    /**
     * @generated from protobuf enum value: DECISION_TOOL_HOME = 2;
     */
    HOME = 2,
    /**
     * @generated from protobuf enum value: DECISION_TOOL_JOB = 3;
     */
    JOB = 3,
    /**
     * @generated from protobuf enum value: DECISION_TOOL_CAR = 4;
     */
    CAR = 4,
    /**
     * @generated from protobuf enum value: DECISION_TOOL_FINANCED_PURCHASE = 5;
     */
    FINANCED_PURCHASE = 5,
    /**
     * @generated from protobuf enum value: DECISION_TOOL_INSURANCE = 6;
     */
    INSURANCE = 6
}
// @generated message type with reflection information, may provide speed optimized methods
class FinancialPlanScenarios$Type extends MessageType<FinancialPlanScenarios> {
    constructor() {
        super("backend.v1.FinancialPlanScenarios", [
            { no: 1, name: "abi_plan", kind: "message", T: () => FinancialPlanData },
            { no: 2, name: "naive_plan", kind: "message", T: () => FinancialPlanData }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.FinancialPlanScenarios
 */
export const FinancialPlanScenarios = new FinancialPlanScenarios$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PlanJob$Type extends MessageType<PlanJob> {
    constructor() {
        super("backend.v1.PlanJob", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "kind", kind: "enum", T: () => ["backend.v1.PlanJob.Kind", PlanJob_Kind, "KIND_"] },
            { no: 3, name: "state", kind: "enum", T: () => ["backend.v1.PlanJob.State", PlanJob_State, "STATE_"] },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "finished_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "family_version", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "plan_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "scenario_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.PlanJob
 */
export const PlanJob = new PlanJob$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreatePlanJobRequest$Type extends MessageType<CreatePlanJobRequest> {
    constructor() {
        super("backend.v1.CreatePlanJobRequest", [
            { no: 1, name: "start_date", kind: "message", T: () => Date }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.CreatePlanJobRequest
 */
export const CreatePlanJobRequest = new CreatePlanJobRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StoredPlan$Type extends MessageType<StoredPlan> {
    constructor() {
        super("backend.v1.StoredPlan", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "start_date", kind: "message", T: () => Date },
            { no: 4, name: "family_version", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "engine_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "plans", kind: "message", T: () => FinancialPlanScenarios },
            { no: 7, name: "shortfall_fixes_state", kind: "enum", T: () => ["backend.v1.ShortfallFixesState", ShortfallFixesState, "SHORTFALL_FIXES_STATE_"] },
            { no: 8, name: "shortfall_fixes", kind: "message", T: () => ShortfallFixes },
            { no: 9, name: "pending_job", kind: "message", T: () => PlanJob },
            { no: 10, name: "failed_job", kind: "message", T: () => PlanJob }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.StoredPlan
 */
export const StoredPlan = new StoredPlan$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateScenarioRequest$Type extends MessageType<CreateScenarioRequest> {
    constructor() {
        super("backend.v1.CreateScenarioRequest", [
            { no: 1, name: "tool", kind: "enum", T: () => ["backend.v1.DecisionTool", DecisionTool, "DECISION_TOOL_"] },
            { no: 2, name: "changes", kind: "message", T: () => Questionnaire },
            { no: 3, name: "inputs", kind: "message", T: () => Struct },
            { no: 4, name: "start_date", kind: "message", T: () => Date },
            { no: 5, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "comparison_changes", kind: "message", T: () => Questionnaire }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.CreateScenarioRequest
 */
export const CreateScenarioRequest = new CreateScenarioRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RenameScenarioRequest$Type extends MessageType<RenameScenarioRequest> {
    constructor() {
        super("backend.v1.RenameScenarioRequest", [
            { no: 1, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.RenameScenarioRequest
 */
export const RenameScenarioRequest = new RenameScenarioRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Scenario$Type extends MessageType<Scenario> {
    constructor() {
        super("backend.v1.Scenario", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "tool", kind: "enum", T: () => ["backend.v1.DecisionTool", DecisionTool, "DECISION_TOOL_"] },
            { no: 3, name: "inputs", kind: "message", T: () => Struct },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "expires_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "family_version", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "plan", kind: "message", T: () => FinancialPlanData },
            { no: 8, name: "job", kind: "message", T: () => PlanJob },
            { no: 9, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "comparison_plan", kind: "message", T: () => FinancialPlanData }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.Scenario
 */
export const Scenario = new Scenario$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListScenariosResponse$Type extends MessageType<ListScenariosResponse> {
    constructor() {
        super("backend.v1.ListScenariosResponse", [
            { no: 1, name: "scenarios", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Scenario }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.ListScenariosResponse
 */
export const ListScenariosResponse = new ListScenariosResponse$Type();
